// CanadaCompanyRegistration.jsx - FIXED with TORONTO SKYLINE IMAGE
import React from "react";

export default function CanadaCompanyRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Canada Company Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Canada Company Registration - Corporations Canada
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses with Canada Company Registration under federal Corporations Canada or provincial laws.
          </p>
          <p className="text-gray-700">
            Complete incorporation including NUANS name search, Articles of Incorporation, corporate minute book, and compliance across Ontario, BC, Quebec registries.[web:1]
          </p>
        </div>

        {/* Right: TORONTO FINANCIAL DISTRICT - Perfect for Canada incorporation */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100 bg-gradient-to-br from-gray-100 to-gray-200">
            <img
              src="https://images.unsplash.com/photo-1544716277-9d8e2e7d5e56?w=1200&h=1200&fit=crop&crop=entropy&auto=format&q=85"
              alt="Toronto Canada financial district skyline for Corporations Canada company registration"
              className="w-full h-[400px] md:aspect-square object-cover block"
              loading="eager"
              onError={(e) => {
                e.target.src = "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1200&h=1200&fit=crop&auto=format&q=85";
              }}
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Canada Company Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation for federal/provincial approvals.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Identity proof (passport copies for directors/shareholders)</li>
                <li>Business details (incorporation name, NUANS report, activities, structure)</li>
                <li>Address information (registered office, principal place of business)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Comprehensive expertise across federal Corporations Canada and provincial registries.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Canadian Corporate Law Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete CBCA knowledge, NUANS searches, Articles of Incorporation, director consents, share structure, bilingual Quebec compliance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise NUANS reports, Articles preparation, initial resolutions, minute books, director registers, provincial filings.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trusted Professional Services
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end from name reservation to certificate issuance, CRA BN applications, bank introductions, first-year compliance.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
